import { render, staticRenderFns } from "./ChangePlanConfirmation.vue?vue&type=template&id=5d2d5f64&"
import script from "./ChangePlanConfirmation.vue?vue&type=script&lang=js&"
export * from "./ChangePlanConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports